export default __webpack_public_path__ + "static/media/image5.a5c99a3a.png";